import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-alert__msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bf-alert', `bf-alert--${_ctx.variant}`]),
    role: "alert"
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(['bf-alert__icon', _ctx.icon])
    }, null, 2),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.message), 1),
    _createElementVNode("button", {
      type: "button",
      class: "bf-alert__close",
      "aria-label": "Fechar",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAlert && _ctx.closeAlert(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "ri-close-line" }, null, -1)
    ]))])
  ], 2))
}